import React from 'react';
import { B as Button } from './Button-DJQVVE0-.js';
import { C as Chip } from './Chip-BoKhEDVA.js';
import './tslib.es6-DN65qNZS.js';
import '@jobber/design';
import { a as ComboboxContext } from './ComboboxProvider-DdsdhWRT.js';

function ComboboxActivator(props) {
    const { handleClose, open, setOpen } = React.useContext(ComboboxContext);
    if (props.children.type === Button || props.children.type === Chip) {
        return React.cloneElement(props.children, {
            role: "combobox",
            onClick: () => {
                if (open) {
                    handleClose();
                }
                else {
                    setOpen(true);
                }
            },
        });
    }
    return props.children;
}

export { ComboboxActivator as C };
